/**
 * AG Grid v36 theme tokens overridden from ag-grid.css defaults.
 * Apply on selectors with specificity above [class*=ag-theme-] (0,1,0), e.g.
 * &.ag-theme-balham (0,2,0) or & .ag-root-wrapper (0,2,0).
 */
export default (theme) => ({
    '--ag-borders': 'none',
    '--ag-borders-critical': 'solid 1px',
    '--ag-border-color': theme.colors.grey[100],
    '--ag-secondary-border-color': theme.colors.grey[100],
    '--ag-row-border-color': theme.colors.grey[100],
    '--ag-row-border-style': 'solid',
    '--ag-row-border-width': '1px',
    '--ag-wrapper-border-radius': '6px',
    '--ag-header-background-color': theme.colors.actionMinor[50],
    '--ag-header-cell-hover-background-color': theme.colors.actionMinor[100],
    // Custom theme has no selected-row background; keep AG Grid default neutral.
    '--ag-selected-row-background-color': 'transparent',
    '--ag-header-height': '40px',
    '--ag-pinned-column-border': `solid 1px ${theme.colors.grey[100]}`,
    // v36 paints pinned-top row borders via this token even when the row is empty.
    '--ag-pinned-row-border': 'none',
});
